import { ssg, sss } from "./common-utils.ts";
import { SiteSearchQuery } from "../search/SiteSearchQuery.ts";

export const truncateWords = (characters: string, length: number) => {
    if (length >= characters.length) return characters;

    let oldResult = /\s/.test(characters.charAt(length));
    // back up from the maxlength char until you find a space
    for (let i = length - 1; i > -1; i--) {
      const currentResult = /\s/.test(characters.charAt(i))
        if (oldResult && !currentResult) {
            return `${characters.substring(0, i + 1)}`;
        }
        oldResult = currentResult;
    }
    // if the string is "length" long with no spaces, we'll get here
    return '(...)';
}

// Run the search from the current form state, resetting to the first page. The form populates a typed,
// extensible SiteSearchQuery (term + filters + page) which is what gets submitted to the site — the single
// serialization seam future advanced filters / a fetch-based results component plug into (CPACWEB-432 PR4).
export const search_submitForm = () => {
    SiteSearchQuery.fromSearchForm().withPage(1).submit()
}
export const search_handleEnterKeyboardEvent = (e: Event) => {
    if (e instanceof KeyboardEvent) {
        if (e.key === 'Enter') {
            search_submitForm();
        }
    }
}
export const search_handleSpaceKeyboardEvent = (e: Event) => {
    if (e instanceof KeyboardEvent) {
        if (e.key === 'Space') {
            search_submitForm();
        }
    }
}
export const search_truncateDescriptions = () => {
    const ul = document.getElementById("search-result-list-main")
    if (ul) {
        const kids = ul.children.length
        for (let i = 0; i < kids; i++) {

            const holder = document.getElementById("searchResultHolder-" + i)
            const textSpan = document.getElementById("searchResultDescription-" + i)
            if (holder && textSpan) {
                const orig = textSpan.innerText == null ? "" : textSpan.innerText
                const text = truncateWords(orig, 225)
                textSpan.innerText = text
                if (orig.length > text.length) {
                    const ellipsisSpan = document.createElement("span")
                    ellipsisSpan.setAttribute("class", "description__ellipsis")
                    ellipsisSpan.innerText = "(...)"
                    textSpan.append(ellipsisSpan)
                }
            }
        }
    }
}

// Paginate: keep the active search (the URL's term + filters) and change only the page. (Replaces the
// program/tag-id URL juggling: those ids now travel with the query the form submits, so a filter change
// runs a single clean search instead of the former racy setProgramId/setTagId/submit trio.)
export const search_setPage = (newPage: number) => {
    SiteSearchQuery.fromLocation().withPage(newPage).submit()
}

export const normalizeForSearch = (text: string) => {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

// this is for the search by date in the search page
export const search_toggleAccordion = () => {
  const key = "searchByDateAccordionIsOpen";
  let prev = ssg(key);
  if (prev == null) {
    prev = false;
  }
  sss(key, !prev);
  search_updateAccordion();
}

// optional close search-by-date accordion 
export const search_closeAccordion = () => {
  const key = "searchByDateAccordionIsOpen";
  sss(key, false);
  search_updateAccordion();
}

export const search_updateAccordion = () => {
  const element = document.getElementById("search_accordion_item");

  if (element) {
    const searchTitle = document.getElementById("search-filter-title");
    let isOpen = ssg("searchByDateAccordionIsOpen");
    if (isOpen == null) isOpen = false;
    element.setAttribute(
      "class",
      isOpen
        ? "accordion accordion--showContent"
        : "accordion accordion--hideContent",
    );
    searchTitle?.setAttribute("aria-expanded", isOpen ? "true" : "false");
    var panel = element.querySelector(".accordion-content-description");
    var startDate = document.getElementById("startDate");
    var endDate = document.getElementById("endDate");
    var navBtnsPrev = element.querySelectorAll(".rdp-button_previous");
    var navBtnsNext = element.querySelectorAll(".rdp-button_next");
    var selectedDayBtn = element.querySelectorAll(".rdp-selected .rdp-day_button");
    var todayBtn = element.querySelectorAll(".rdp-today .rdp-day_button");
    var startDateInput = document.getElementById("startDate-date-input");
    var endDateInput = document.getElementById("endDate-date-input");

    if (panel && !isOpen) {
      panel.setAttribute("style", "max-height: 0px");
      panel.setAttribute("aria-hidden", "true");
      startDate?.setAttribute("tabindex", "-1");
      endDate?.setAttribute("tabindex", "-1");
      navBtnsPrev?.forEach((btn) => btn.setAttribute("tabindex", "-1"));
      navBtnsNext?.forEach((btn) => btn.setAttribute("tabindex", "-1"));
      selectedDayBtn?.forEach((btn) => btn.setAttribute("tabindex", "-1"));
      todayBtn?.forEach((btn) => btn.setAttribute("tabindex", "-1"));
      startDateInput?.setAttribute("tabindex", "-1");
      endDateInput?.setAttribute("tabindex", "-1");
    } else if (panel && isOpen) {
      panel.setAttribute("style", "max-height: " + (panel.scrollHeight + 20) + "px");
      panel.setAttribute("aria-hidden", "false");
      startDate?.setAttribute("tabindex", "0");
      endDate?.setAttribute("tabindex", "0");
      navBtnsPrev?.forEach((btn) => btn.setAttribute("tabindex", "0"));
      navBtnsNext?.forEach((btn) => btn.setAttribute("tabindex", "0"));
      selectedDayBtn?.forEach((btn) => btn.setAttribute("tabindex", "0"));
      todayBtn?.forEach((btn) => btn.setAttribute("tabindex", "0"));
      startDateInput?.setAttribute("tabindex", "0");
      endDateInput?.setAttribute("tabindex", "0");
    }
  }
}

export const search_showApplyButton = () => {
  const applyButton: HTMLElement | null =
    document.getElementById("apply-button");
  if (applyButton) {
    applyButton.setAttribute("class", "apply-button isVisible");
    applyButton?.setAttribute("tabindex", "0");
  }
}